import { DataCellProps } from '../../types';

const CountDataCell = ({ _customRowProps, countofdatatype }: DataCellProps) => {
  return <div>{countofdatatype}</div>;
};

export default CountDataCell;
